import classes from "./SelectionActionButton.module.scss";
import { ButtonHTMLAttributes } from "react";
import { className } from "utils/strings";

type SelectionActionButtonProps = {
  iconUrl: string;
  text: string;
} & ButtonHTMLAttributes<HTMLButtonElement>

export const SelectionActionButton = (props: SelectionActionButtonProps) => {
  const { text, iconUrl, ...buttonProps } = props;

  const buttonClassName = className({
    [classes.button]: true,
    [props.className ?? ""]: true,
  });

  return (
    <button {...{ ...buttonProps, className: buttonClassName }}>
      <img className={classes.icon} src={iconUrl} width={28} height={28} alt="" />
      <span className={classes.text}>{ text }</span>
    </button>
  );
};
